import type { RarityResult } from "@/lib/conditions/rarity";

type Props = {
  rarity: RarityResult | null;
};

export function RarityBadge({ rarity }: Props) {
  if (!rarity) return null;

  const isTop5 = rarity.tier === "top5";

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-bold ${
        isTop5
          ? "bg-gold/15 text-gold border border-gold/30"
          : "bg-amber-50 text-amber-700 border border-amber-200"
      }`}
      aria-label={rarity.label}
    >
      <span aria-hidden>{isTop5 ? "✦" : "◆"}</span>
      {rarity.label}
    </div>
  );
}
